module.exports = __webpack_public_path__ + "img/camera.7b25f2f5.svg";